import { render, staticRenderFns } from "./ProgramsSlider.vue?vue&type=template&id=0b8d1ff4&"
import script from "./ProgramsSlider.vue?vue&type=script&lang=js&"
export * from "./ProgramsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsSlider.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProgramsSlider.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ProgramsSlider.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports